import { connectedStore } from '../../store';
import getClipboardDataSelector from '../selectors/clipboard-data';

const getClipboardData = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return getClipboardDataSelector(state);
};

export default getClipboardData;
